const LOOP_GUARD_MS = 15000;

export default async function () {
  if (process.env.NODE_ENV === 'development') {
    const now = Date.now();
    const lastRedirect = parseInt(
      sessionStorage.getItem('_login_redirect_ts') || '0',
    );

    if (now - lastRedirect < LOOP_GUARD_MS) {
      console.warn(
        '[loginRedirector] Already redirected to login %ds ago, skipping.',
        Math.round((now - lastRedirect) / 1000),
      );
      return;
    }

    sessionStorage.setItem('_login_redirect_ts', String(now));
    window.location.href = '/dev-clear-cookies';
  } else if (process.env.NODE_ENV === 'branch') {
    window.location.href = 'https://testso.n11.com/selleroffice/login';
  } else {
    window.location.href = '/selleroffice/login';
  }
}
